export default __webpack_public_path__ + "static/media/LoginRightImage.4b0c71a1.png";